import React from 'react'
import {Route, Routes} from 'react-router-dom';
import Login from '../pages/Login';
import {UserContext} from '../UserContext';
import {Backdrop, CircularProgress} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Register from '../pages/Register';
import ForgotMyPassword from '../pages/ForgotMyPassword';
import PolicyCookies from '../pages/PolicyCookies';
import ResetPassword from '../pages/ResetPassword';
import Contact from '../pages/Contact';

const JustNotLoginRoutes = () => {
    const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: 9999,
            color: '#fff',
        },
    }));

    const classes = useStyles();

    const [open, setOpen] = React.useState(true);
    const handleClose = () => {
        setOpen(false);
    };

    const {loading} = React.useContext(UserContext);

    return (
        <>
            {loading &&
                <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
                    <CircularProgress color="inherit"/>
                </Backdrop>
            }
            <Routes>
                <Route path="/" element={<Login/>}/>
                <Route path="/login" element={<Login/>}/>
                <Route path="/cadastro" element={<Register/>}/>
                <Route path="/politica-de-cookies" element={<PolicyCookies/>}/>
                <Route path="/contato" element={<Contact/>}/>
                <Route path="/esqueci-minha-senha" element={<ForgotMyPassword/>}/>
                <Route path="/password/reset" element={<ResetPassword/>}/>
            </Routes>            
        </>
    )
}

export default JustNotLoginRoutes;